<span [attr.data-test-id]="'cell-text-' + rowIndex + '-' + cellIndex">
  {{ tableRowData[tableCellAttribute.key] }}
</span>
